import cn from 'clsx';

const LoadingWrapper = ({
  children,
  loading,
  compact,
}: {
  children: any;
  loading?: boolean;
  compact?: boolean;
}) => {
  return (
    <div
      className={cn('w-full  relative', {
        ['animate-fadeBeat']: loading,
        ['h-full']: !compact,
      })}
    >
      {children}
      {loading && <div className={'absolute top-0 left-0 right-0 bottom-0 z-[1000]'} />}
    </div>
  );
};

export default LoadingWrapper;
